import { render, staticRenderFns } from "./ChatDomainLaunchNotice.vue?vue&type=template&id=a6e492ba&scoped=true"
import script from "./ChatDomainLaunchNotice.vue?vue&type=script&lang=js"
export * from "./ChatDomainLaunchNotice.vue?vue&type=script&lang=js"
import style0 from "./ChatDomainLaunchNotice.vue?vue&type=style&index=0&id=a6e492ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e492ba",
  null
  
)

export default component.exports